<template>
    <button class="btn btn-danger" :class="btnClass" :disabled="poster.submitted" @click="triggerPost()">
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        manager: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/managers/' + this.manager.id + '/deleteAccount'
        }
    },

    methods: {
        posterSuccess (data) {
            bus.$emit(
                'notify',
                'Kontot har raderats'
            )
            this.$emit('success')
        },
        triggerPost() {
            if ( !confirm("Vill du verkligen ta bort kontot? Det kan inte ångras.")){
              return
            }
            this.posterPost()
        }
    }
}
</script>
